export const DEFAULT_LIGHT_THEME = 'light';
export const DEFAULT_DARK_THEME = 'dark';
export const DEFAULT_SYSTEM_THEME = 'system';

export const DEFAULT_STORAGE_KEY = 'theme';
export const DEFAULT_ATTRIBUTE = 'data-theme';

export const DEFAULT_THEMES = [DEFAULT_LIGHT_THEME, DEFAULT_DARK_THEME];
// Browser color schemes
export const COLOR_SCHEMES = [DEFAULT_LIGHT_THEME, DEFAULT_DARK_THEME];

export const DARK_THEME_MEDIA_QUERY = '(prefers-color-scheme: dark)';
